import React from "react";
import { Button, Col, Form, Input, Layout, message, Row } from "antd";
import { useForm } from "antd/es/form/Form";
import { useTranslation } from "react-i18next";
import { useResetPasswordMutation } from "../graphql/generated/hooks";
import { useNavigate, useParams } from "react-router-dom";
import { PASSWORD_RULES } from "../common/constants";

function ResetPassword() {
  const { t } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();
  const params = useParams();
  const [form] = useForm();
  const [resetPassword, { loading }] = useResetPasswordMutation();

  const onFinish = async (values: any) => {
    await resetPassword({
      variables: {
        token: params.token ?? "",
        newPassword: values.new_password,
      },
    }).then((res) => {
      if (res.data?.resetPassword) {
        messageApi.success(t("message.success.reset_password"));
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } else {
        messageApi.error(t("message.error.reset_password"));
      }
    });
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Row>
        <Col xl={4} offset={10} style={{ marginTop: 50 }}>
          {contextHolder}
          <Form
            form={form}
            onFinish={onFinish}
            layout="vertical"
            style={{ marginTop: "20px" }}
          >
            <Form.Item
              rules={[
                { required: true, message: t("message.error.field_required") },
                ...PASSWORD_RULES.map((rec) => ({
                  ...rec,
                  message: t(rec.message),
                })),
              ]}
              hasFeedback
              name="new_password"
              label={t("label.enter_new_password")}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              name="new_password_confirmation"
              label={t("label.enter_new_password_confirmation")}
              dependencies={["new_password"]}
              hasFeedback
              rules={[
                { required: true, message: t("message.error.field_required") },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("new_password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "The new password that you entered do not match!"
                      )
                    );
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
              <Button loading={loading} type="primary" htmlType="submit">
                {t("button.send")}
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </Layout>
  );
}

export default ResetPassword;
